<template>
  <div
    v-if="roleId && image"
    class="
      d-flex
      flex-column
      justify-content-center
      align-items-center
      h-100
      bg-white
      p-2
    "
  >
    <figure class="ui-figure">
      <CButton class="ui-figure__delete" @click.stop="modalShow = true"
        ><font-awesome-icon icon="trash-alt"
      /></CButton>
      <CRow class="ui-figure__badges" v-if="!filterStatus">
        <CBadge color="primary" class="mb-2" v-if="isGalleryImage">{{
          $t("role.profile.tab_images.filter_type.gallery")
        }}</CBadge>
        <CBadge color="primary" class="mb-2" v-if="isSlideShowImage">{{
          $t("role.profile.tab_images.filter_type.slideshow")
        }}</CBadge>
        <CBadge color="primary" class="mb-2" v-if="isBackgroundImage">{{
          $t("role.profile.tab_images.filter_type.background")
        }}</CBadge>
      </CRow>
      <img :src="image.image_sm" class="w-100 ui-figure__img__medialibrary" />
    </figure>

    <CModal
      :title="$t('role.data.profileImages.modal.title')"
      :show.sync="modalShow"
      :closeOnBackdrop="false"
      :centered="true"
      @click.native.stop
    >
      <p>
        {{ $t("role.data.profileImages.modal.subtitle") }}
      </p>
      <p>
        {{ $t("role.data.profileImages.modal.text") }}
      </p>
      <template #footer>
        <CButton color="primary" @click.stop="onModalConfirm">{{
          $t("common.editor.button.confirm")
        }}</CButton>
        <CButton color="primary" variant="outline" @click.stop="onModalClose">{{
          $t("common.editor.button.cancel")
        }}</CButton>
      </template>
    </CModal>
  </div>
  <div v-else class="loading">
    <CSpinner color="secondary" size="lg" />
  </div>
</template>

<script>
import { create, method } from "lodash";
import {
  apiPatch,
  apiGet,
  apiDelete,
  apiPost,
} from "../../../helpers/apiHelper";

export default {
  data() {
    return {
      imageData: null,
      modalShow: false,
    };
  },

  props: {
    roleId: Number,
    image: Object,
    filterStatus: String,
  },

  computed: {
    isGalleryImage() {
      return this.image && this.image.image && this.image.image.gallery;
    },
    isSlideShowImage() {
      return this.image && this.image.image && this.image.image.slideshow;
    },
    isBackgroundImage() {
      return this.image && this.image.image && this.image.image.background;
    },
  },

  methods: {
    onModalClose() {
      this.modalShow = false;
    },

    onModalConfirm() {
      this.modalShow = false;
      this.onRemove(this.image.id);
    },

    async onRemove(id) {
      const response = await apiDelete("role_imagecrop", id, [
        this.$store.state.role.id,
      ]);
      if (response && response.status === 200) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.data.profileImages.modal.deleteSuccess"),
          color: "success",
          autohide: true,
        });
        this.$emit("refresh");
      } else {
        console.error("Unexpected response:", response);
        this.$store.dispatch("toaster/add", {
          title: this.$t("common.editor.messages.ko.title"),
          text: this.$t("role.data.profileImages.modal.deleteFailed"),
          color: "info",
          autohide: true,
        });
      }
    },
  },
};
</script>
